import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useCurrentPregnancyChartsDataContext } from './hooks/useCurrentPregnancyChartsDataContext';

export const PreNatalConsultations = () => {
    const { chartData } = useCurrentPregnancyChartsDataContext();


    return (
        <SimpleBars
            title={'Total de consultas pré-natal'}
            horizontal={false}
            subtitles={chartData?.preNatalConsultations?.map((item) => item.description)}
            values={chartData?.preNatalConsultations?.map((item) => item.total  ||  0)}
        />
    );
};
